import { Divider, Grid, Typography, useTheme } from '@mui/material'
import { useEffect } from 'react'
import { BsCheck } from 'react-icons/bs'
import { ReactComponent as Retour } from '../assets/Retour.svg'
import { ReactComponent as WalterLearning } from '../assets/WalterLearning.svg'
import { ReactComponent as WalterSanteColor } from '../assets/WalterSanteColor.svg'
import { BackToGroupLink, CallUs, Formtitle } from '../components'
import { learningPhoneNumber, santePhoneNumber } from '../utils/constants'
import { FormType } from '../utils/sharedTypes'
import { BiTimer } from 'react-icons/bi'

type OpcoValidationPropsType = {
  form: FormType
}

const OpcoValidation = ({ form }: OpcoValidationPropsType) => {
  const theme = useTheme()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {
    console.log(form.data.global_id, form.data.validated)
    if (form.data.global_id && !form.data.validated) {
      setTimeout(() => {
        window.location.reload()
      }, 5000)
    }
  }, [form.data.validated])

  return (
    <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: '100vh', p: 2 }}>
      {form.data.validated ? (
        <>
          <Grid item xs={12} sm={10} md={6}>
            <Grid container direction="column" justifyContent="center" alignItems="center">
              <Grid
                item
                sx={{
                  background: theme.palette.success.main,
                  height: 80,
                  width: 80,
                  borderRadius: 40,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  mb: 3,
                }}
              >
                <BsCheck size="40px" style={{ color: 'white' }} />
              </Grid>
              <Typography variant="h4" sx={{ textAlign: 'center' }}>
                Merci !
              </Typography>
              <Typography variant="body2" sx={{ textAlign: 'center', mt: 1 }}>
                Votre paiement a bien été reçu, un lien d'accès à la plateforme d'apprentissage vient d'être envoyé à{' '}
                <span style={{ whiteSpace: 'nowrap' }}>{form.data.email}</span>.
              </Typography>
            </Grid>
          </Grid>
          <Grid
            item
            container
            direction="column"
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              pt: 2,
              pl: { xs: 2, md: 4 },
              display: 'flex',
            }}
          >
            <Grid item container sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
              <Grid item>
                {location.pathname.includes('/sante') ? (
                  <WalterSanteColor
                    width="162px"
                    onClick={() => {
                      window.open('https://walter-learning.com/sante', '_self')
                    }}
                  />
                ) : (
                  <WalterLearning
                    width="180px"
                    onClick={() => {
                      window.open('https://walter-learning.com', '_self')
                    }}
                  />
                )}
              </Grid>
              <Grid item>
                <Divider orientation="vertical" sx={{ height: 40, mx: 2 }} />
              </Grid>
              <Grid
                item
                sx={{
                  // flexGrow: { xs: 1, sm: 0 },
                  justifyContent: 'space-between',
                  display: 'flex',
                  alignItems: 'center',
                }}
                onClick={() => {
                  location.pathname.includes('/sante')
                    ? window.open('https://walter-learning.com/sante', '_self')
                    : window.open('https://walter-learning.com', '_self')
                }}
              >
                <Retour />
                <Typography variant="body1" sx={{ ml: 1 }}>
                  Retour au site
                </Typography>
              </Grid>
            </Grid>
            {form.data.registration_group && (
              <Grid item sx={{ mt: 1.5 }}>
                <BackToGroupLink registrationGroup={form.data.registration_group} />
              </Grid>
            )}
          </Grid>

          <Grid
            sx={{
              position: 'absolute',
              top: 0,
              right: 0,
              mt: 2,
              mr: 4,
              display: { xs: 'none', md: 'block' },
            }}
          >
            <CallUs phone={form.data.theme === 'sante' ? santePhoneNumber : learningPhoneNumber} />
          </Grid>
        </>
      ) : (
        <>
          <Grid container justifyContent="center">
            <Grid container justifyContent="center">
              <Grid
                item
                sx={{
                  background: theme.palette.grey[500],
                  height: 80,
                  width: 80,
                  borderRadius: 40,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <BiTimer color="inherit" size="40" />
              </Grid>
            </Grid>
            <Formtitle title="Le traitement de votre paiement est en cours..." align="center" />
          </Grid>
        </>
      )}
    </Grid>
  )
}

export default OpcoValidation
